import _classNames from 'clsx';
import React from 'react';
import Button from '../button/button';
function Chip(props) {
    var _a = props.classes, classes = _a === void 0 ? '' : _a, text = props.text, _b = props.type, type = _b === void 0 ? 'default' : _b, onDelete = props.onDelete;
    return (React.createElement("div", { className: _classNames('Chip', "Chip--type-".concat(type), classes) },
        React.createElement("span", { className: "Chip__text" }, text),
        typeof onDelete === 'function' && (React.createElement("div", null,
            React.createElement(Button, { classes: "Chip--type-sim__button", iconRight: "Close", iconRightColor: "white", buttonProps: { type: 'button' }, onClick: function () { return onDelete(text); } })))));
}
export default Chip;
